import { Lista } from './lista'

export class ListaItem {
  idListaItem: number;
  codigoItem: string;
  valorItem: string;
  indicadorHabilitado: boolean;
  lista: Lista;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/lista-item.ts